import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { StarRatingDisplay } from '@nexus/fff-ratings-and-reviews';

import styles from './ProductRatingsTitle.module.css';

const formatNumber = (num) => num.toLocaleString('en-US');

const ProductRatingsTitle = ({
  writtenReviewsCount,
  totalReviewCount,
  averageRating,
  isOpen,
}) => {
  const mobileRatingLabel = `${averageRating} of 5 | ${formatNumber(
    totalReviewCount
  )} Reviews`;
  const reviewReviews = writtenReviewsCount === 1 ? 'Review' : 'Reviews';
  const ratingRatings = totalReviewCount === 1 ? 'Rating' : 'Ratings';
  const ratingLabel = `${averageRating} of 5 Stars | ${formatNumber(
    totalReviewCount
  )}
    ${ratingRatings}, ${formatNumber(
    writtenReviewsCount
  )} Written ${reviewReviews}`;
  return (
    <div>
      <div
        id="rate-and-review-header"
        className={styles.ratingDetailsContainer}
      >
        <h2 id={styles.reviewTitle}>Reviews</h2>
        <StarRatingDisplay
          rating={averageRating}
          ratingCount={totalReviewCount}
          showOnlyStars={isMobile}
          ratingLabel={ratingLabel}
          size="large"
          theme="pink"
        />
      </div>
      {isOpen && isMobile && (
        <div className={styles.productRatingText}>
          <p>{mobileRatingLabel}</p>
        </div>
      )}
    </div>
  );
};

ProductRatingsTitle.propTypes = {
  averageRating: PropTypes.number.isRequired,
  totalReviewCount: PropTypes.number.isRequired,
  writtenReviewsCount: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default ProductRatingsTitle;
